import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import {useEnvironmentStore} from '@di-shared/features/environment/environmentStore';
import {RegionType} from '@shared/cci/features/const/environment';
import React from 'react';
import IntroduceBottomSheetEu from '@di-shared/features/home/eu/IntroduceBottomSheet.eu';
import IntroduceBottomSheetKr from '@di-shared/features/home/kr/IntroduceBottomSheet.kr';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 500;

function IntroduceBottomSheetPage() {
  const region = useEnvironmentStore((state) => state.region);

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      {region === RegionType.EU ? <IntroduceBottomSheetEu /> : <IntroduceBottomSheetKr />}
    </BottomSheetWebViewWrapper>
  );
}

export default IntroduceBottomSheetPage;
